import SpendFactor from "./SpendFactor";
import useSpendFactorStore from "./store";

export default SpendFactor;

export { useSpendFactorStore };
